import { toast, ToastOptions } from 'react-toastify';

const toaster = {
  error: (text: string, options?: ToastOptions | undefined) => {
    toast(text, { ...options, type: 'error' });
  },

  success: (text: string, options?: ToastOptions | undefined) => {
    toast(text, { ...options, type: 'success' });
  },

  info: (text: string, options?: ToastOptions | undefined) => {
    toast(text, { ...options, type: 'info' });
  },

  warning: (text: string, options?: ToastOptions | undefined) => {
    toast(text, { ...options, type: 'warning' });
  }
};

export default toaster;
